import React, { useState, useEffect, useRef } from "react";
import { voteApi, getUserId } from "../../api";
import { IoClose } from "react-icons/io5";
import "./BallotProgressPanel.css";

const BallotProgressPanel = () => {
    const [showPanel, setShowPanel] = useState(false);
    const [progressData, setProgressData] = useState(null);
    const panelRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setShowPanel(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        fetchProgressData();
        // Set up polling to refresh data every 10 seconds
        const interval = setInterval(() => {
            fetchProgressData();
        }, 10000);

        // Listen for vote submission events to immediately refresh
        const handleVoteSubmitted = () => {
            console.log('Vote submitted event received, refreshing progress...');
            fetchProgressData();
        };

        window.addEventListener('voteSubmitted', handleVoteSubmitted);

        return () => {
            clearInterval(interval);
            window.removeEventListener('voteSubmitted', handleVoteSubmitted);
        };
    }, []);

    // Refetch data whenever the panel is opened
    useEffect(() => {
        if (showPanel) {
            fetchProgressData();
        }
    }, [showPanel]);

    const fetchProgressData = async () => {
        try {
            const userId = getUserId();
            if (!userId) return;

            const response = await voteApi.get(`/v2/VotesControllerV/Ballot-progress-panel?userId=${userId}`);
            if (response.data && response.data.success) {
                setProgressData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching progress data:", error);
        }
    };

    if (!progressData) return null;

    return (
        <div className="ballot-progress-panel-wrapper" ref={panelRef}>
            {/* Progress Icon - Fixed Position */}
            <div className="ballot-progress-icon-fixed" onClick={() => setShowPanel(!showPanel)} title="View Progress">
                <svg viewBox="0 0 36 36" className="bpp-circular-chart">
                    <path className="bpp-circle-bg"
                        d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path className="bpp-circle"
                        strokeDasharray={`${progressData.percentage}, 100`}
                        d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                </svg>
                <span className="bpp-percentage-text">{Math.round(progressData.percentage)}%</span>
            </div>

            {/* Progress Panel Dropdown */}
            {showPanel && (
                <div className="ballot-progress-dropdown">
                    <div className="bpp-card">
                        <div className="bpp-card-top">
                            <span>Ballots Completed</span>
                            <span className="highlight">{progressData.percentage}%</span>
                        </div>
                        <div className="bpp-bar-container">
                            <div className="bpp-bar-fill" style={{ width: `${progressData.percentage}%` }}></div>
                        </div>
                        <div className="bpp-card-bottom">
                            <span>Started</span>
                            <span className="highlight">{progressData.totalUserRespondedVotes} completed</span>
                            <span>{progressData.totalAvailableVotes - progressData.totalUserRespondedVotes} remaining</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BallotProgressPanel;
